"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'tutorialDetail',
  data: function data() {
    return {
      id: this.$route.params.id || 1,
      info: {}
    };
  },
  mounted: function mounted() {
    this.getDetail();
  },
  methods: {
    /**
     * 文章详情
     */
    getDetail: function getDetail(row) {
      var _this = this;
      this.$get('agentapi/article/detail', {
        id: this.id
      }).then(function (res) {
        _this.info = res.info;
      });
    }
  }
};